<template>
    <div v-if="page_show" style="padding-top: 1rem">
        <navTitle
                :title="$router.app._route.query.ti ? $router.app._route.query.ti : $t('message.recharge.title')"></navTitle>
        <div class="game-tips" v-if="first_money>0">
            <!--        <div class="game-tips">-->
            <!--            FIRST TIME TOP-UP₫200 REWARD₫{{frist_money}}-->
            <!--            {{$t('message.recharge.first_deposit')}} {{first_money}}₫-->
            Lần sạc ₫ầu tiên ₫50.000 nhận ₫10.000
        </div>
        <div class="recharge">
            <!--<div class="nav acea-row row-around row-middle">
                <div class="item on">
                    {{$t('message.recharge.use_binance')}}
                </div>
            </div>-->
            <p class="switch-info">{{$t('message.recharge.choose_amount')}}</p>
            <div class="info-wrapper">
                <div class="money-switch">
                    <template>
                        <div v-if="first_gift_amount_flag">
                            <div class="switch-item1" :class="switch_index==index?'switch-click':''"
                                 v-for="(item,index) in money_banks_arr" v-key="index"
                                 @click="switchItem(item,index)">
                                <span style="font-size: .3rem">{{item|MoneyFormat}}₫</span>
                                <div class="gift-amount" :class="switch_index==index?'gift-switch-click':''">
                                    <lable v-if="!recharged_amount.includes(item)">+{{getQuantity(item)}}%</lable>
                                    <label v-else>---</label>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="switch-item2" :class="switch_index==index?'switch-click':''"
                                 v-for="(item,index) in money_banks_arr" v-key="index"
                                 @click="switchItem(item,index)">
                                <span style="font-size: .3rem">{{item|MoneyFormat}}₫</span>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="tips">
                    {{$t('message.recharge.current_balance')}}<span> {{ parseInt(now_money) |MoneyFormat }}₫</span>
                </div>

                <!--                <select class="select-pay" v-model="vnpropay_type">-->
                <!--                    <option value="">xin vui lòng chọn</option>-->
                <!--                    &lt;!&ndash;<option value="907">Ngân hàng trực tuyến để thanh toán</option>-->
                <!--                    <option value="908">Chuyển khoản ngân hàng</option>-->
                <!--                    <option value="909">Quét mã để thanh toán</option>-->
                <!--                    <option value="1025">Zalo 支付</option>-->
                <!--                    <option value="923">Momo trả tiền</option>-->
                <!--                    <option value="925">VTpay trả tiền</option>&ndash;&gt;-->
                <!--                    <option value="1011">Ngân hàng trực tuyến để thanh toán</option>-->
                <!--                    <option value="1012">Chuyển khoản ngân hàng</option>-->
                <!--                    <option value="1013">Quét mã để thanh toán</option>-->
                <!--                    <option value="1025">Zalo trả tiền</option>-->
                <!--                    <option value="1027">Momo trả tiền</option>-->
                <!--                    <option value="1029">VTpay trả tiền</option>-->
                <!--                </select>-->
                <div class="pay-btn bg-color-blue" @click="recharge">
                    {{$t('message.recharge.confirm_top_up')}}
                </div>
            </div>
        </div>
        <div class="list" v-if="applyList.length > 0">
            <div class="title">{{$t('message.recharge.application_details')}}</div>
            <div class="li" v-for="item in applyList">
                <div class="row">{{$t('message.recharge.order_number')}}:{{ item.order_id }}</div>
                <div class="row">{{$t('message.recharge.application_time')}}:{{ item.add_time }}</div>
                <div class="row">{{$t('message.recharge.top_up_amount')}}:{{ parseInt(item.price) |MoneyFormat}}₫</div>
                <div class="row">
                    {{$t('message.recharge.top_up_status')}}:
                    <span v-if="item.state == 0">{{$t('message.recharge.reviewing')}}</span>
                    <span v-if="item.state == 1"
                          style="color: #40B883">{{$t('message.recharge.application_success')}}</span>
                    <span v-if="item.state == 2"
                          style="color: #dd3823">{{$t('message.recharge.application_failed')}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {
        recharge_info,
        recharge_apply_list, payment_create,
        getChannelUseInfo
    } from "../../api/user";

    import navTitle from "@components/navTitle";

    export default {
        name: "Recharge",
        components: {navTitle},
        props: {},
        data: function () {
            return {
                money: 50000,
                now_money: "",
                usdt_money: "",
                vnpropay_type: "",
                applyList: [],
                money_banks_arr: [20000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000],
                switch_index: 1,
                first_money: 0,
                path_url: "/user/pay",
                third_pay_channel: '',
                first_gift_amount_flag: false,
                gift_list: [],
                recharged_amount: [],
                page_show: false
            };
        },
        computed: mapGetters(["userInfo"]),
        mounted: function () {
            this.now_money = this.userInfo.now_money;
            this.getList();
            this.getApplyList();
            this.getChannelUseInfo();
        },
        methods: {
            convertToObj(arr) {
                const result = {};
                arr.forEach(item => {
                    const [amount, quantity] = item.split(",");
                    result[parseInt(amount)] = parseInt(quantity);
                });
                return result;
            },
            getQuantity(a) {
                const dataObj = this.convertToObj(this.gift_list);
                return dataObj[a] || 0;
            },
            getChannelUseInfo() {
                let that = this
                getChannelUseInfo().then(res => {
                    that.gift_list = res.data.gift_prop_arr
                    that.recharged_amount = res.data.recharged_amount
                    that.first_gift_amount_flag = res.data.recharge_gift_open===1?true:false
                }).catch(res => {
                    // console.log(res)
                })
            },
            switchItem(money, index) {
                this.money = money
                this.switch_index = index
            },
            getList() {
                this.$dialog.loading.open("Loading...");
                recharge_info().then(res => {
                    this.third_pay_channel = res.data.third_pay_channel
                    this.$dialog.loading.close();
                    this.first_money = res.data.first_recharge_award
                    this.page_show = true
                })
                    .catch(res => {
                        this.$dialog.loading.close();
                    });
            },
            getApplyList() {
                recharge_apply_list({
                    page: 1,
                    limit: 999
                }).then(res => {
                    this.applyList = res.data.list;
                });
            },
            recharge: function () {
                let that = this;
                if (this.money > 0) {
                    if (this.money < 100) {
                        return this.$dialog.toast({mes: this.$t('message.recharge.msg_minimum_bank')});
                    }

                    /*if (this.vnpropay_type === '') {
                        return this.$dialog.toast({mes: 'Vui lòng chọn hình thức thanh toán'});
                    }
                    if (this.vnpropay_type === '1011' || this.vnpropay_type === '1012' || this.vnpropay_type === '1013') {
                        if (this.money < 50000) {
                            return this.$dialog.toast({mes: 'Số tiền thanh toán mã quét không được nhỏ hơn 20000'});
                        }
                    }*/
                    let path
                    if (this.third_pay_channel === 2)
                        path = '/user/Recharge_channel'
                    if (this.third_pay_channel === 3){
                        // path = '/user/Recharge_info'
                        const param = {
                            amount: this.money
                        }
                        payment_create(param).then(res => {
                            this.$dialog.loading.close()
                            let pay_res = res.data
                            window.location.href = pay_res.link_url
                        }).catch(res => {
                            this.$dialog.loading.close()
                            return this.$dialog.error(res.data.msg)
                        })
                    }
                    if (this.third_pay_channel === 4)
                        return this.$dialog.toast({mes: 'Kênh thanh toán đang bảo trì'});
                    this.$router.push({
                        // path: '/user/Recharge_channel',
                        // path: '/user/Recharge_info',
                        path: path,
                        query: {money: this.money}
                    })
                    // console.log(this.vnpropay_type)
                    return
                    payment_create({
                        amount: this.money,
                        phone: this.phone,
                        vnpro_channel: this.vnpropay_type,
                    }).then(res => {
                        this.$dialog.loading.close()
                        let pay_res = res.data
                        // console.log(pay_res)
                        window.location.href = pay_res.link_url
                    }).catch(res => {
                        this.$dialog.loading.close()
                        return this.$dialog.error(res.data.msg)
                    })
                    // console.log(this.money)
                    /*this.$router.push({
                        path: this.path_url,
                        query: {
                            m: this.money,
                            // u1: this.my_cash[this.active].phone,
                            // type: this.my_cash[this.active].type,
                            // cid: this.my_cash[this.active].id
                        }
                    });*/
                } else {
                    this.$dialog.toast({mes: this.$t('message.recharge.msg_enter_top_up_amount')});
                }
            }
        }
    };
</script>
<style scoped>
    #iframe {
        display: none;
    }

    .game-tips {
        width: 100%;
        height: 0.6rem;
        line-height: 0.6rem;
        background: rgba(254, 211, 44, 0.6);
        color: #333;
        position: fixed;
        text-align: center;
        top: 1rem;
        left: 0px;
        right: 0px;
        z-index: 3000;
    }

    .recharge {
        width: 7.03rem;
        padding: 0.5rem 0.63rem 0.45rem;
        background-color: #fff;
        margin: 0.2rem auto 0 auto;
        border-radius: 0.1rem;
    }

    .recharge .nav {
        height: 0.75rem;
        line-height: 0.75rem;
        /*padding: 0 1rem;*/
        margin-bottom: 1rem;
    }

    .recharge .nav .item {
        font-size: 0.3rem;
        color: #333;
    }

    .recharge .nav .item.on {
        font-weight: bold;
        border-bottom: 0.04rem solid #00c3f9;
    }

    .recharge .info-wrapper {
        text-align: center;
    }

    .recharge .info-wrapper .money {
        margin-top: 0.6rem;
        padding-bottom: 0.2rem;
        border-bottom: 1px dashed #ddd;
    }

    .recharge .info-wrapper .money span {
        font-size: 0.56rem;
        color: #333;
        font-weight: bold;
    }

    .recharge .info-wrapper .money input {
        display: inline-block;
        width: 3rem;
        font-size: 0.84rem;
        text-align: center;
        color: #282828;
        font-weight: bold;
        padding-right: 0.7rem;
    }

    .recharge .info-wrapper .money input::placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-webkit-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input::-moz-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .money input:-ms-input-placeholder {
        color: #ddd;
    }

    .recharge .info-wrapper .tips {
        font-size: 0.26rem;
        color: #888;
        margin: 0.25rem auto 0 auto;
        line-height: 1.5;
        padding: 0 0.3rem;
    }

    .recharge .info-wrapper .tips span {
        color: #ef4a49;
    }

    .recharge .info-wrapper .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }

    .list {
        width: 100%;
        padding: 0 0.3rem;
        box-sizing: border-box;
        margin-top: 0.3rem;
        background: #fff;
    }

    .list .title {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.3rem;
        border-bottom: 2px solid #00c3f9;
        text-align: center;
    }

    .list .li {
        margin-bottom: 0.15rem;
        border-bottom: 1px dashed #ccc;
        margin-top: 0.15rem;
    }

    .list .li {
        padding: 0.15rem 0;
    }

    .list .li .row {
        width: 100%;
        line-height: 0.5rem;
        height: 0.5rem;
    }

    .money-switch {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .money-switch .switch-item {
        width: 30%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        height: 50px;
        margin-right: 10px;
        color: #333;
        font-size: 0.4rem;
    }

    .money-switch .switch-item1 {
        width: 30%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 25px;
        color: #333;
        font-size: 0.36rem;
        margin-left: 2.5%;
        float: left;
    }

    .money-switch .switch-item2 {
        width: 30%;
        border: 1px solid #ccc;
        border-radius: 3px;
        margin-bottom: 10px;
        line-height: 50px;
        color: #333;
        font-size: 0.36rem;
        margin-left: 2.5%;
        float: left;
    }

    .gift-amount{
        width: 86%;
        margin-left: 7%;
        border-top: 1px dashed darkgrey;
        color: darkgrey;
        font-size: .3rem;
    }

    .money-switch .switch-item:nth-child(3n) {
        margin-right: 0px;
    }

    .money-switch .switch-item1:nth-child(3n) {
        margin-right: 0px;
    }

    .switch-click {
        border: 1px solid #00c3f9 !important;
        color: #00c3f9 !important;

    }

    .gift-switch-click {
        font-weight: bold;
        color: goldenrod !important;

    }

    .switch-info {
        margin-bottom: 10px;
        color: #666;
        /*text-align: center;*/
    }

    .text_title {
        margin-top: -3px;
        margin-bottom: 2.5px;
        color: red;
    }

    .text_title i {
        font-size: 0.2rem;
    }

    .usdt {
        font-size: .3rem;
    }

    .usdt_info1 {
        /*color: red;*/
        font-size: .1rem;
        margin-top: -.2rem;
        height: .3rem;
        position: relative;
    }

    .usdt_info2 {
        margin: 0;
        font-size: .3rem;
        height: .3rem;
        position: relative;
    }

    .select-pay {
        margin-top: .2rem;
        padding: .2rem;
        border: 2px solid #ddd;
        width: 85%;
    }
</style>
